import { useState, useEffect } from 'react';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import IndustriesSection from './components/IndustriesSection';
import AboutSection from './components/AboutSection';
import CTASection from './components/CTASection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import CookieConsent from '../../components/feature/CookieConsent';
import { 
  useSchemaOrg, 
  getOrganizationSchema, 
  getProfessionalServiceSchema, 
  getWebPageSchema,
  getLocalBusinessSchema 
} from '../../utils/seo';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  // Add Schema.org structured data
  useSchemaOrg([
    getOrganizationSchema(),
    getProfessionalServiceSchema(),
    getWebPageSchema(),
    getLocalBusinessSchema()
  ]);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white relative">
      {/* Circuit Board Background */}
      <div 
        className="fixed inset-0 pointer-events-none z-0"
        style={{
          backgroundImage: `url('https://static.readdy.ai/image/c07ed6529feea951012003251bff6ba4/78a627228f114a68e878a20237e5938e.jpeg')`,
          backgroundRepeat: 'repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.15
        }}
      ></div>
      
      <div className="relative z-10">
        <HeroSection scrolled={scrolled} />
        <ServicesSection />
        <IndustriesSection />
        <AboutSection />
        <CTASection />
        <ContactSection />
        <Footer />
      </div>

      <CookieConsent />
    </div>
  );
}
